// import React, { useEffect, useId, useState } from 'react';
// import { useRecoilState, useRecoilValueLoadable } from 'recoil';
// // import { entityDetailsSelectorFamily, generateFilterKey } from '../../../Services/_states/Entity/entityDetailsSelector.ts';
// // import { entityDetailsStateAtomFamily } from '../../../Services/_states/index.js';
// import useDebounce from '../../Shared/Delay/index.tsx';
// import SearchableDropdown from '../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
// import { entityDetailsStateAtomFamily } from '../../../Services/_states/Entity/entity.ts'; // ✅ correct
// import { entityDetailsSelectorFamily, generateFilterKey } from '../../../Services/_states/Entity/entityDetailsSelector.ts'; // ✅ correct

// interface EntityDropdownProps {
//   value: any;
//   onChange: (value: any) => void;
//   entityFormId: string;
//   // parentFormId:string;
//   label?: any;
//   error?: boolean;
//   errorMessage?: string;
//   disabled?: boolean;
//   sx?: any;
//   selectedEntityFields?: any[];
//   displayField?: string;
//   parentEntityId?: string;
// }

// const EntityDetailsDropdown: React.FC<EntityDropdownProps> = ({
//   value = null,
//   onChange,
//   entityFormId,
//   // parentFormId,
//   label = 'Select Entity',
//   error = false,
//   errorMessage = '',
//   disabled = false,
//   sx = {},
//   selectedEntityFields = [],
//   displayField = '',
//   parentEntityId = "" // Optional prop to specify which field to display in the dropdown
// }) => {
//   const uniqueKey = entityFormId;
//   const [searchQuery, setSearchQuery] = useState('');
//   const debouncedSearch = useDebounce(searchQuery, 500);
//   const [tableState, setTableState] = useRecoilState(entityDetailsStateAtomFamily(uniqueKey));
//   const fetchedData = useRecoilValueLoadable(entityDetailsSelectorFamily(uniqueKey));
//   const [filteredEntities, setFilteredEntities] = useState < any[] > ([]);
//   const [openDropdown, setOpenDropdown] = useState(false);
//   const filterKey = generateFilterKey(tableState.filters);
//   useEffect(() => {
//     if (!openDropdown) return;

//     setTableState((prev) => {

//       const newFilters = {
//         ...prev.filters,
//         search: debouncedSearch,
//         page: 1,
//         entityFormId,
//       };
//       if (parentEntityId) {
//         newFilters.parentEntityId = parentEntityId;
//         newFilters.entityFormId = "";
//       }

//       return {
//         ...prev,
//         filters: newFilters,
//       };
//     });
//   }, [debouncedSearch, entityFormId, parentEntityId, openDropdown]);

//   useEffect(() => {
//     if (
//       fetchedData.state === 'hasValue' &&
//       !fetchedData.contents.fromCache &&
//       !tableState.cache[filterKey]
//     ) {
//       if (tableState?.filters?.parentEntityId) {
//         setTableState((prev) => ({
//           ...prev,
//           cache: { [filterKey]: fetchedData.contents.data },
//           totalCountCache: { [filterKey]: fetchedData.contents.totalCount },
//         }));
//       } else {
//         setTableState((prev) => ({
//           ...prev,
//           cache: { ...prev.cache, [filterKey]: fetchedData.contents.data },
//           totalCountCache: { ...prev.totalCountCache, [filterKey]: fetchedData.contents.totalCount },
//         }));

//       }
//     }
//   }, [fetchedData, setTableState, filterKey, tableState.cache]);

//   useEffect(() => {
//     const allValues = Object.values(tableState.cache).flat();
//     const uniqueEntities = allValues.reduce((acc: any[], curr: any) => {
//       if (!acc.some(item => item._id === curr._id)) acc.push(curr);
//       return acc;
//     }, []);
//     setFilteredEntities(uniqueEntities);
//   }, [tableState.cache]);

//   const loadMoreEntities = () => {
//     const total = tableState.totalCountCache[filterKey] || 0;
//     const currentCount = Object.values(tableState.cache).flat().length;

//     if (total > currentCount) {
//       setTableState((prev) => ({
//         ...prev,
//         filters: { ...prev.filters, page: prev.filters.page + 1 },
//       }));
//     }
//   };
//   const displayKey = displayField ? displayField : selectedEntityFields[0];
//   return (
//     <SearchableDropdown
//       options={filteredEntities || []}
//       label={label}
//       value={value || null}
//       onChange={onChange}
//       valueKey="_id"
//       onSearch={setSearchQuery}
//       searchValue={searchQuery}
//       fetchMoreOptions={loadMoreEntities}
//       loading={fetchedData.state === 'loading'}
//       error={error}
//       errorMessage={errorMessage}
//       disabled={disabled}
//       sx={sx}
//       getOptionLabel={(option) => displayKey ? option?.entity?.[displayKey] : option?.entity[Object?.keys(option?.entity)[0]] ?? option?._id}
//       onOpen={() => {
//         setOpenDropdown(true);
//       }}
//       onClose={() => {
//         setOpenDropdown(false);
//       }}
//     />
//   );
// };

// export default EntityDetailsDropdown;

// import React, { useEffect, useState } from 'react';
// import useDebounce from '../../Shared/Delay/index.tsx';
// import SearchableDropdown from '../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
// import { LeadFormActions } from '../../../Services/_actions/index.js';
// import { EntityActions } from '../../../Services/_actions/Entity/entity.actions.ts';

// interface EntityDropdownProps {
//   value: any;
//   onChange: (value: any) => void;
//   entityFormId: string;
//   label?: any;
//   error?: boolean;
//   errorMessage?: string;
//   disabled?: boolean;
//   sx?: any;
//   selectedEntityFields?: string[];
//   queryParams?: { param?: string; paramValue?: string; matched_with?: string }[];
//   displayField?: string;
//   parentEntityId?: string;
// }

// const EntityDetailsDropdown: React.FC<EntityDropdownProps> = ({
//   value = null,
//   onChange,
//   entityFormId,
//   label = 'Select Entity',
//   error = false,
//   errorMessage = '',
//   disabled = false,
//   sx = {},
//   selectedEntityFields = [],
//   queryParams = [],
//   displayField = 'value',
//   parentEntityId = '',
// }) => {
//   const [searchQuery, setSearchQuery] = useState('');
//   const debouncedSearch = useDebounce(searchQuery, 500);
//   const [options, setOptions] = useState<any[]>([]);
//   const [loading, setLoading] = useState(false);
//   const [openDropdown, setOpenDropdown] = useState(false);
//   const action = EntityActions();

//   useEffect(() => {
//     if (!openDropdown) return;

//     const fetchEntities = async () => {
//       try {
//         setLoading(true);
//         const response = await action.getEntityDropdown(
//           entityFormId,
//           selectedEntityFields,
//           queryParams
//         );
//         const items = response?.items || [];
//         setOptions(items);
//       } catch (err) {
//         console.error('Failed to fetch entity data:', err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchEntities();
//   }, [
//     debouncedSearch,
//     entityFormId,
//     parentEntityId,
//     selectedEntityFields,
//     openDropdown,
//     // loaded,
//   ]);

//   // useEffect(() => {
//   //   if (!phoneNumber) {
//   //     setOptions([]);
//   //   }
//   // }, [phoneNumber]);

//   const selectedOption = value
//     ? options.find((opt) => opt._id === (value._id || value))
//     : null;

//   return (
//     <SearchableDropdown
//       options={options}
//       label={label}
//       onChange={(option) => {
//         onChange(option ? option : null);
//       }}
//       value={selectedOption}
//       valueKey="_id"
//       getOptionLabel={(option) => option?.[displayField] || option?._id}
//       onSearch={setSearchQuery}
//       searchValue={searchQuery}
//       loading={loading}
//       error={error}
//       errorMessage={errorMessage}
//       disabled={disabled}
//       sx={sx}
//       onOpen={() => setOpenDropdown(true)}
//       onClose={() => setOpenDropdown(false)}
//     />
//   );
// };

// export default EntityDetailsDropdown;

import React, { useEffect, useState } from "react";
import { useRecoilValueLoadable } from "recoil";
import useDebounce from "../../Shared/Delay/index.tsx";
import SearchableDropdown from "../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx";
import { entityDropdownSelector } from "../../../Services/_states/Entity/entityDropdownSelector.ts";

interface EntityDropdownProps {
  value: any;
  onChange: (value: any) => void;
  entityFormId: string;
  label?: any;
  error?: boolean;
  errorMessage?: string;
  disabled?: boolean;
  sx?: any;
  selectedEntityFields?: string[];
  queryParams?: { param?: string; paramValue?: string; matched_with?: string }[];
  displayField?: string;
  autoSelect?: boolean
}

const EntityDetailsDropdown: React.FC<EntityDropdownProps> = ({
  value = null,
  onChange,
  entityFormId,
  label = "Select Entity",
  error = false,
  errorMessage = "",
  disabled = false,
  sx = {},
  selectedEntityFields = [],
  queryParams = [],
  displayField = "value",
  autoSelect = false,
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const debouncedSearch = useDebounce(searchQuery, 500);

  const dropdownLoadable = useRecoilValueLoadable(
    entityDropdownSelector({
      entityFormId,
      returnFields: selectedEntityFields,
      queryParams,
    })
  );

  const loading = dropdownLoadable.state === "loading";
  const options = dropdownLoadable.state === "hasValue" ? dropdownLoadable.contents : [];

  const selectedOption = value
    ? options.find((opt: any) => opt._id === (value._id || value))
      ?? (typeof value === "object" ? value : { _id: value, value })
    : null;

  const getOptionValue = (option: any) => {
    const values = [
      option?.[displayField],
      option?.entity?.[displayField],
      ...selectedEntityFields.flatMap((field) => [
        option?.[field],
        option?.entity?.[field],
      ]),
    ];

    return values.find((fieldValue) => fieldValue != null && fieldValue !== "");
  };

  useEffect(() => {
    if (options?.length === 1 && autoSelect) {
      onChange(options[0])
    }
  }, [options])

  return (
    <SearchableDropdown
      options={options}
      label={label}
      onChange={(option) =>
        onChange(option ? { ...option, value: getOptionValue(option) ?? option.value } : null)
      }
      value={selectedOption}
      valueKey="_id"
      getOptionLabel={(option) => getOptionValue(option) || option?._id}
      onSearch={setSearchQuery}
      searchValue={searchQuery}
      loading={loading}
      error={error}
      errorMessage={errorMessage}
      disabled={disabled}
      sx={sx}
      onOpen={() => { }}
      onClose={() => { }}
    />
  );
};

export default EntityDetailsDropdown;
